import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-125cb256"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "portfolioSummary" }
const _hoisted_2 = { class: "mobile-hidden" }
const _hoisted_3 = { class: "portfolioSummary__tile" }
const _hoisted_4 = { class: "portfolioSummary__tile" }
const _hoisted_5 = {
  key: 0,
  class: "portfolioSummary__tile"
}
const _hoisted_6 = { class: "portfolioSummary__buttons" }
const _hoisted_7 = { style: {"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column"} }
const _hoisted_8 = { style: {"display":"inline-flex","align-items":"center","justify-content":"center","flex-wrap":"wrap","padding":"10px 0"} }
const _hoisted_9 = { style: {"margin":"20px 10px"} }
const _hoisted_10 = { style: {"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column"} }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { style: {"text-transform":"capitalize"} }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { style: {"text-transform":"capitalize"} }
const _hoisted_15 = { class: "validationPopup__btn" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "C4E", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode($setup["C4EIcon"], {
          size: "100",
          icon: "c4e-grey-new"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("PORTFOLIO_VIEW.TOKEN_PRICE")), 1 /* TEXT */),
        _createElementVNode("h4", null, [
          _createVNode($setup["CoinAmount"], {
            amount: $setup.calculatePrice(1000000,$setup.useTokensStore().getTokenPrice),
            "default-view-denom": "$",
            precision: 6,
            "show-denom": true,
            "denom-as-prefix": true
          }, null, 8 /* PROPS */, ["amount"])
        ]),
        _createCommentVNode(" <h5>$<FormattedNumber :amount=\"amountToUSD(totalBalance)\" :precision=\"2\"/></h5> ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("PORTFOLIO_VIEW.BALANCE")), 1 /* TEXT */),
        _createElementVNode("h4", null, [
          (_openBlock(), _createBlock($setup["CoinAmount"], {
            key: $setup.totalBalance,
            amount: $setup.convertAmount($setup.totalBalance),
            precision: 2,
            "show-tooltip": true,
            "reduce-big-number": true,
            "show-denom": true
          }, null, 8 /* PROPS */, ["amount"]))
        ]),
        _createCommentVNode(" <h5>$<FormattedNumber :amount=\"amountToUSD(totalBalance)\" :precision=\"2\"/></h5> ")
      ]),
      ($setup.totalBalance !== $setup.spendableBalance)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("PORTFOLIO_VIEW.SPENDABLE")), 1 /* TEXT */),
            _createElementVNode("h4", null, [
              (_openBlock(), _createBlock($setup["CoinAmount"], {
                key: $setup.spendableBalance,
                amount: $setup.convertAmount($setup.spendableBalance),
                precision: 2,
                "show-tooltip": true,
                "reduce-big-number": true,
                "show-denom": true
              }, null, 8 /* PROPS */, ["amount"]))
            ]),
            _createCommentVNode(" <h5>$<FormattedNumber :amount=\"amountToUSD(spendableBalance)\" :precision=\"2\"/></h5> ")
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Button, {
          class: "secondary portfolioSummary__button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => $setup.receiveDialogVisible = true, ["prevent"])),
          disabled: !$setup.userStore.getAccount.address
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("PORTFOLIO_VIEW.RECEIVE")), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled"]),
        _createVNode(_component_Button, {
          class: "secondary portfolioSummary__button",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => $setup.sendDialogVisible = true, ["prevent"])),
          disabled: !$setup.userStore.getAccount.address
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("PORTFOLIO_VIEW.SEND")), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled"])
      ])
    ]),
    _createVNode($setup["Dialog"], {
      visible: $setup.receiveDialogVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (($setup.receiveDialogVisible) = $event)),
      modal: "",
      header: _ctx.$t("PORTFOLIO_VIEW.RECEIVE"),
      style: { width: '95vw', 'max-width': '600px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("PORTFOLIO_VIEW.ADDRESS")), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString($setup.userStore.getAccount.address), 1 /* TEXT */),
            _createVNode($setup["Copy"], {
              onClick: $setup.copyTxt,
              class: "copy_button"
            })
          ]),
          _createVNode($setup["QrcodeVue"], {
            value: $setup.userStore.getAccount.address,
            size: "200",
            "render-as": 'svg'
          }, null, 8 /* PROPS */, ["value"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible", "header"]),
    _createVNode($setup["Dialog"], {
      visible: $setup.sendDialogVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (($setup.sendDialogVisible) = $event)),
      modal: "",
      header: _ctx.$t("PORTFOLIO_VIEW.SEND"),
      style: { width: '95vw', 'max-width': '600px'}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("PORTFOLIO_VIEW.SEND")), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_11, [
            _createVNode($setup["Field"], {
              modelValue: $setup.targetAddress,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.targetAddress) = $event)),
              name: "targetAddress",
              placeholder: " ",
              type: "text",
              class: "form-control",
              style: {"width":"100%"}
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('COMMON.INPUT.ADDRESS')), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode($setup["Field"], {
              modelValue: $setup.amount,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.amount) = $event)),
              name: "amount",
              placeholder: " ",
              type: "number",
              class: "form-control",
              style: {"width":"100%"}
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('COMMON.INPUT.AMOUNT')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                onClick: _withModifiers($setup.simulate, ["prevent"]),
                disabled: !$setup.enableButton
              }, "Max", 8 /* PROPS */, _hoisted_16),
              _hoisted_17
            ])
          ]),
          _createVNode(_component_Button, {
            class: "secondary",
            onClick: $setup.handleSend,
            disabled: !$setup.enableButton
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("PORTFOLIO_VIEW.SEND")), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible", "header"])
  ], 64 /* STABLE_FRAGMENT */))
}